import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

const gitlabCiCard = EntityCardBlueprint.make({
  name: 'gitlab-ci',
  params: {
    type: 'info',
    filter: entity =>
      Boolean(entity.metadata.annotations?.['gitlab.com/project-slug']),
    loader: async () =>
      import('./GitlabCiCard').then(m => <m.GitlabCiCard />),
  },
});

export const gitlabCiModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [gitlabCiCard],
});
